// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.area-report[data-v-1033bcea] {\n  width: 100%;\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 16px;\n}\n.area-content[data-v-1033bcea] {\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  padding: 0;\n  background-color: #fff;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
